import { useQuery } from "@tanstack/react-query";
import { sendErrorReport } from "../../../utils/reporting";
import { fetchAirlines } from "../../api/airlines";
import { extractAirlineData } from "../serializers/intake-funnel";
import { Airline } from "../types/intake-funnel";

const FIVE_MINUTES = 5 * 60 * 1000;

export function useAirlineSearch(debouncedSearchTerm: string) {
  const isSearchStringCorrect = !!debouncedSearchTerm && debouncedSearchTerm.length >= 2;

  const { data, isError, isFetching } = useQuery<Airline[] | undefined, Error>({
    queryKey: [`api/airlines?q=${debouncedSearchTerm}`],
    queryFn: async () => {
      if (!isSearchStringCorrect) return;

      try {
        const rawAirlines = await fetchAirlines(debouncedSearchTerm);

        return rawAirlines.map((airline) => {
          return extractAirlineData(airline);
        });
      } catch (error) {
        sendErrorReport(error, "Error on airlines search");
      }
    },
    retry: 2,
    enabled: isSearchStringCorrect,
    staleTime: FIVE_MINUTES,
  });

  return {
    airlines: data,
    isError,
    isFetching,
  };
}
